module.exports = __webpack_public_path__ + "0114a9d95870f2f794445f6ba867e43a.jpg";